import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components are located in src/components/
import Login from "./components/Login";
import MainMenu from "./components/MainMenu";
import UrlShortener from "./components/UrlShortener";
import AdminDashboard from "./components/AdminDashboard";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/main" element={<MainMenu />} />
            <Route path="/urlshortener" element={<UrlShortener />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;